import gql from 'graphql-tag'

export const CREATE_COURSE_VERIFICATION = gql`
  mutation academyCreateVerifyCourseRequest($input: CourseCompleteVerifyRequestInput!) {
    academyCreateVerifyCourseRequest(input: $input) {
      id
    }
  }
`

export const UPDATE_COURSE_VERIFICATION = gql`
  mutation academyUpdateVerifyCourseRequest($enrollId: Int!, $verifyStatus: VerifyStatus) {
    academyUpdateVerifyCourseRequest(enrollId: $enrollId, verifyStatus: $verifyStatus) {
      id
      verifyStatus
      verifyUser {
        fullName
      }
    }
  }
`
